import styled from 'styled-components';
import { COLOURS, getBodyFont, isFocused } from '@belong/themes';
import { Button as DefaultButton } from '../../actions';
import { withLink } from '../../hocs';

export const Root = styled.nav`
  background-color: ${COLOURS.BLACK};
  ${getBodyFont('small')}
`;

export const Button = styled(DefaultButton)`
  color: ${COLOURS.BELONG_BLUE};

  &:focus {
    color: ${COLOURS.BELONG_BLUE};
  }
`;

export const List = styled.ol`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 1rem 0 2rem;
`;

export const ListItem = styled.li`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  color: ${COLOURS.WHITE};

  a {
    color: ${COLOURS.BELONG_BLUE};
  }

  &:last-child a {
    color: ${COLOURS.WHITE};
  }
`;

export const CurrentItem = styled.span`
  padding: 0.8rem 0;
`;

export const Link = withLink(styled.a`
  padding: 0.8rem 0;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    ${isFocused()};
  }
`);
